import { Typography } from '@mui/material'
import { t } from 'i18next'
import theme from 'lib/theme'
import { ExtraProduct } from 'types/model/product'
import { RequiredPill } from './OrderProduct.styled'

export const ProductColPills = ({
  required,
  extraProduct,
}: {
  required: boolean
  extraProduct: ExtraProduct | undefined
}) => {
  if (!required && !extraProduct) return null

  const backgroundColor =
    extraProduct === ExtraProduct.DISCOUNT ||
    extraProduct === ExtraProduct.EXTERNAL_DISCOUNT
      ? theme.palette.error.main
      : theme.palette.text.secondary

  const extraProductTranslation = () => {
    if (extraProduct === ExtraProduct.ACCOUNTING_CHARGE) {
      return t('accountingCharge')
    }
    if (extraProduct === ExtraProduct.EXTERNAL_DISCOUNT) {
      return t('externalDiscount')
    }
    return t(extraProduct?.toLowerCase() ?? '')
  }

  return (
    <RequiredPill sx={extraProduct ? { backgroundColor } : {}}>
      <Typography
        variant='body2'
        fontSize='10px'
        sx={{ color: theme.palette.commonColors.white }}>
        {extraProduct
          ? extraProductTranslation().toUpperCase()
          : t('required').toUpperCase()}
      </Typography>
    </RequiredPill>
  )
}
